import React from 'react'
import { useDebouncedValue, QueryParamsObserver } from 'labguard-cdk'
import useAlarm from './useAlarm'
import useNote from './useNote'
import useEnclosingPeriod from './useEnclosingPeriod'

/**
 * Hook providing a 'zoom' prop calculated with zoom from the store and potential alarm or note from the url parameters
 */
export default function useZoom() {
  // get zoom from query params
  const zoomFrom = QueryParamsObserver.useValue('zoomFrom')
  const zoomTo = QueryParamsObserver.useValue('zoomTo')
  const from = React.useMemo(() => zoomFrom && new Date(zoomFrom), [zoomFrom])
  const to = React.useMemo(() => zoomTo && new Date(zoomTo), [zoomTo])

  // get current alarm if any
  const alarm = useAlarm()

  // get current note if any
  const note = useNote()

  // get computed period
  const period = useEnclosingPeriod()

  // get memoized computed zoom floored to the second
  const zoom = React.useMemo(
    () =>
      (alarm
        ? [alarm.startDate, alarm.endDate || period.to]
        : note
        ? [note.startDate, note.endDate]
        : [from || period.from, to || period.to]
      ).map(date => new Date(date.setMilliseconds(0))),
    [alarm, note, from, to, period]
  )

  // really update zoom when it stops updating (after 100ms)
  return useDebouncedValue(100)(zoom)
}
